

export const SalvagePage = () => {
    return (
        <div>
            Salvage And Recycling Page
        </div>
    )
}

export default SalvagePage